import { Platform } from 'react-native';

/**
 * Cross-platform safe wrapper around MUI's `useGridApiRef`.
 * – On web: lazily re-exports the real hook from `@mui/x-data-grid-pro`.
 * – On native: returns a stub that mimics the shape of the ref and prevents runtime errors.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useGridApiRef: () => { current: any } =
  Platform.OS === 'web'
    ? // eslint-disable-next-line @typescript-eslint/no-var-requires, import/no-extraneous-dependencies
      (require('@mui/x-data-grid-pro').useGridApiRef as () => { current: any })
    : // On native platforms return a dummy ref object
      () => ({ current: null });
